import React from "react";
import { Keyboard } from "lucide-react";
import { useKeyboard } from "../../context/KeyboardContext";

/**
 * Login / signup / forgot-password (mobile & tablet only).
 * Circle FAB bottom-right — toggles on-screen keyboard for inputs.
 */
const AuthKeyboardToggleFab: React.FC = () => {
  const { showAuthToggle, authToggleOn, toggleAuthKeyboard, isOpen } =
    useKeyboard();

  if (!showAuthToggle || isOpen) return null;

  return (
    <button
      type="button"
      data-auth-keyboard-toggle
      aria-label={authToggleOn ? "Turn off on-screen keyboard" : "Turn on on-screen keyboard"}
      aria-pressed={authToggleOn}
      onMouseDown={(e) => e.preventDefault()}
      onClick={toggleAuthKeyboard}
      className={`fixed bottom-6 right-6 z-[999998] flex h-14 w-14 items-center justify-center rounded-full shadow-lg transition-all active:scale-95 ${
        authToggleOn
          ? "bg-[#885ABB] text-white ring-4 ring-[#885ABB]/30"
          : "bg-white text-[#885ABB] ring-1 ring-gray-200"
      }`}
    >
      <Keyboard size={26} strokeWidth={2.25} />
    </button>
  );
};

export default AuthKeyboardToggleFab;
